import { render, staticRenderFns } from "./promo.vue?vue&type=template&id=cbc048a2&scoped=true&"
import script from "./promo.vue?vue&type=script&setup=true&lang=js&"
export * from "./promo.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./promo.vue?vue&type=style&index=0&id=cbc048a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc048a2",
  null
  
)

export default component.exports